import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const stats = [
  { value: 28, suffix: '+', label: 'Years of Experience', desc: 'Delivering excellence since 1998' },
  { value: 45, suffix: 'K+', label: 'Customers Worldwide', desc: 'Trusted globally' },
  { value: 99.98, suffix: '%', label: 'Uptime SLA', desc: 'Guaranteed availability' },
  { value: 24, suffix: '/7', label: 'Emergency Support', desc: 'Always available for you' },
];

const useCountUp = (target, duration = 2000, isVisible) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(0);
  const startRef = useRef(null);

  useEffect(() => {
    if (!isVisible) return;

    const step = (timestamp) => {
      if (!startRef.current) startRef.current = timestamp;
      const elapsed = timestamp - startRef.current;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      countRef.current = target * eased;
      setCount(countRef.current);
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }, [isVisible, target, duration]);

  return target % 1 === 0 ? Math.round(count) : count.toFixed(2);
};

const StatItem = ({ stat }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const count = useCountUp(stat.value, 2000, visible);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="stat-block" ref={ref}>
      <div className="stat-number">
        {count}<span className="stat-suffix">{stat.suffix}</span>
      </div>
      <div className="stat-label-main">{stat.label}</div>
      <div className="stat-desc">{stat.desc}</div>
    </div>
  );
};

const Stats = () => (
  <section className="stats-section">
    <div className="stats-bg-text">aXtion</div>
    <div className="stats-inner">
      <div className="stats-intro fade-up">
        <span className="section-label">// 02 — By The Numbers</span>
        <p>Preparing for your success — delivering results that speak for themselves.</p>
      </div>
      <div className="stats-grid">
        {stats.map((stat, i) => (
          <StatItem key={i} stat={stat} />
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
